import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import type WorkRequestDetailsUpsertVM from 'ab-viewModels/workRequest/workRequestDetailsUpsert.viewModel';

import { Button } from '@acceligentllc/storybook';

import JobContact from 'af-components/SharedForms/Contacts/ContactWrapper';

import { formSectionClassColumn8, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

export type OwnProps = {
	formName: string;
	disabled: boolean;
};

type Props = WrappedFieldArrayProps<WorkRequestDetailsUpsertVM['additionalContacts']> & OwnProps;

const AdditionalContacts: React.FC<Props> = ({ fields, formName, disabled }) => {
	const onAddClick = React.useCallback(() => {
		fields.push(null);
	}, [fields]);

	const showAddContactBtn = !disabled;

	const onRemoveClick = React.useCallback((index: number) => () => fields.remove(index), [fields]);

	const renderAdditionalContact = React.useCallback((_name: string, _index: number) => {
		const additionalContactName = `Additional Contact ${_index + 1}`;
		return (
			<React.Fragment key={_name}>
				<div className={formSectionClassRow}>
					{additionalContactName}
				</div>
				<div className={formSectionClassRow} key={_name}>
					<div className={[formSectionClassColumn8, styles['job-form__additional-contact-container'], styles['job-form__delete-button']].join(' ')}>
						<JobContact
							className={[styles['job-form__additional-contact']].join(' ')}
							contactLabel="Enter Additional Contact"
							fieldName={_name}
							formName={formName}
						/>
						<Button
							icon="Delete"
							onClick={onRemoveClick(_index)}
							style="link-danger"
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}, [formName, onRemoveClick]);

	return (
		<>
			{fields.map(renderAdditionalContact)}
			{showAddContactBtn &&
				<Button
					icon="ActionPlusSmall"
					label="Add Contact"
					onClick={onAddClick}
					style="link"
				/>
			}
		</>
	);
};

export default AdditionalContacts;
